export class AC101SelectAll extends HTMLElement {

  get group() {
    return this.getAttribute('group');
  }

  connectedCallback() {
    this.addEventListener("click", this._onClick);
  }

  _onClick = (e) => {
    for (const element of document.querySelectorAll(
      `[select-all-group="${this.group}"]`
    )) {
      if ("checked" in element) {
        element.checked = true;
      }
    }
  };

}

declare global {
  interface HTMLElementTagNameMap {
    "ac101-select-all": AC101SelectAll;
  }
}

customElements.define('ac101-select-all', AC101SelectAll);
